import React from 'react';

import { Link } from 'react-router-dom';

import { Helmet } from "react-helmet";

const newsletterSeptember2018 = ({ imagePrefix }) => {
  return (
    <div className="content-container article">
      <Helmet>
        <title>The Good News - September 2018 | Elevation of the Holy Cross Sacramento</title>
      </Helmet>

      <div className="header">
        <div className="eyebrows">
          <div className="left">
            Quarterly Newsletter
          </div>
          <div className="right">
            September 2018
          </div>
        </div>

        <h1>The Good News</h1>
        <h2>Elevation of the Holy Cross Orthodox Church, Sacramento</h2>
      </div>

      <div className="body">
        <div className="main-article">
          <img src={ require('../../../assets/images/news/newsletter-september-2018-camp.png') }
               alt="Holy Cross girls from the Heywood, Robertson, Ebrahimi and Green families ready for a week of fun and prayer outdoors." />
          <div className="image-caption">
            Holy Cross girls from the Heywood, Robertson, Ebrahimi and
Green families ready for a week of fun and prayer outdoors.
          </div>

          <div className="section" style={{ marginTop: '16px' }}>
            <h2 className="title">
              St. Eugene’s Youth Camp 2018
            </h2>
            <div className="author">
              by Kathy Pieracci
            </div>

            <div className="article-body">
              <p>
                We went to a new location this year in the
                beautiful hills, close to the south entrance to
                Yosemite, at Sugar Pine Christian Camp in
                Oakhurst. Change can be difficult; however, being
                surrounded by the beauty of God’s creation we
                immediately felt at "home," beginning our week
                surrounded with the beauty that God provided for
                us.
              </p>
              <p>
                Our morning prayers, Vespers, and Liturgy services
                were held at our campfire site, along with many
                evenings of wonderful skits, discussions, and of
                course s’mores. All activities were held outside,
                whether we were playing games, doing Arts and
                Crafts or studying the Feast Days of the Theotokos.
                We offered many new activities this year such as
                archery, BB gun targets, canoeing, paddle boarding,
                a ropes course with a zip line, a train ride and
                hikes. We were blessed to have 13 campers and 3
                adult volunteers from our church.
              </p>
              <p>
                Here are a few comments from our campers:
              </p>
              <p>
                <em>"The ropes course and zipline was my favorite. It
                was challenging but fun at the same time."</em>
                <br/>&nbsp;&nbsp;&nbsp;&nbsp;-Amelia
              </p>
              <p>
                <em>"I enjoyed making a stained-glass cross with the
                icon of the Theotokos in the middle."</em><br/>&nbsp;&nbsp;&nbsp;&nbsp;-Lily
              </p>
              <p>
                <em>"I really liked hearing the birds singing and seeing
                the sunshine filter through the trees during
                morning prayers."</em><br/>&nbsp;&nbsp;&nbsp;&nbsp;-Josefine
              </p>
              <p>
                <em>"Learning the Theotokos at the age of 3 walked up
                the stairs to the High Priest"</em><br/>&nbsp;&nbsp;&nbsp;&nbsp;–Lily
              </p>
              <p>
                <em>"Not sure anyone will say anything different than
                ‘Glop’ as my favorite meal."</em><br/>&nbsp;&nbsp;&nbsp;&nbsp;-Josefine
              </p>
              <p>
                <em>"No matter where our little camp family goes, we
                will always have each other to laugh with and
                make memories with."</em><br/>&nbsp;&nbsp;&nbsp;&nbsp;-Georgia
              </p>
            </div>
          </div>
        </div>

        <div className="cols">
          <div className="left">
            <div className="section">
              <h2 className="title">
                On Taking Up the Cross
              </h2>

              <div className="article-body" style={{ clear: 'all' }}>
                <p>
                  <span className="scripture">
                    And He said to them all, If any man will come
                    after Me, let him deny himself, and take up his
                    cross daily, and follow Me. (Luke 9:23)
                  </span>
                </p>
                <p style={{ float: 'right', marginLeft: '2rem' }}>
                  <img src={ require('../../../assets/images/news/newsletter-september-2018-st-innocent.png') } alt="St. Innocent" />
                </p>
                <p>
                  "To take up one’s cross means to accept and bear
                  unmurmuringly everything unpleasant, painful, sad, difficult
                  and oppressive that may happen to us in our life...[to] bear
                  all without malice, without murmuring, without criticism,
                  without complaint, that is, without regarding oneself as
                  offended and without expecting any earthly reward in
                  return; to bear it all with love, with joy and firmness...
                </p>
                <p>
                  "...In whatever position you may be, and whatever sufferings
                  of soul you may feel, do not despair and do not think that
                  the Lord has abandoned you. No! He will always be with
                  you and will invisibly strengthen you even when it seems
                  that you are on the very brink of perdition. He will never
                  allow you to be tempted more than He sees fit. Do not
                  despair and do not be afraid; but with full submission and
                  surrender to Him, have patience and pray. For He is always
                  our Father, and a very loving Father...
                </p>
                <p>
                  "...If you bear your sufferings with submission and surrender
                  to the will of God and do not seek consolation anywhere or
                  in anyone except the Lord, then in His mercy He will not
                  abandon you and will not leave you without consolation; He
                  will touch your heart with His grace and will communicate
                  to you the gifts of the Holy Spirit. Amid your sufferings ...you
                  will feel in your heart ineffable sweetness, a wonderful
                  peace and joy which you never felt before; and at the same
                  time you will feel within you the power and ability to pray
                  to God with true prayer and to believe in Him with true
                  faith. Then your heart will burn with pure love for God and
                  your neighbor..."
                </p>
                <p>
                  —<u>St. Innocent of Alaska</u>, from <u>Indications of the Way into the
                  Kingdom of Heaven</u> (originally written in the Aleut language)
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title">
                Seminary Send Off!
              </h2>

              <div className="article-body">
                We had the joy of sending our own Ryan Patrick Miller to
                St. Tikhon’s Seminary in South Canaan, PA the last week of
                August. We were able to send him off with a blessing and a
                scholarship to begin his studies.
              </div>
            </div>

            <div className="section">
              <h2 className="title">
                Births and Baptisms
              </h2>

              <div className="article-body">
                <ul style={{ paddingLeft: '16px' }}>
                  <li>Avery Olivia Blighton</li>
                  <li>Marie Lorraine Winegar</li>
                  <li>Isaiah Theodore Simonson</li>
                  <li>Emma Vasilisa MacKinnon</li>
                  <li>Elizabeth Brown</li>
                  <li>Esther Rose Duke</li>
                </ul>
              </div>
            </div>

            <div className="section">
              <h3 className="eyebrow">
                Put your faith into action by donating to the
              </h3>
              <h2 className="title">
                Archangel Michael Food Closet
              </h2>

              <div className="article-body">
                <p className="scripture">
                  "I sent you to reap that for
                  which you have not labored;
                  others have labored, and you
                  have entered into their labors."
                  <br/>
                  John 4:38
                </p>

                <h3>
                  All nourishing, nonperishible foods are welcome.<br/>
                  <span style={{ borderBottom: '1px solid rgba(0, 0, 0, .2)' }}>
                    Some special needs for October and upcoming holidays are:
                  </span>
                </h3>

                <ul style={{ paddingLeft: '16px', textAlign: 'left' }}>
                  <li>
                    Canned yams (29oz)
                  </li>
                  <li>
                    Canned cranberry sauce
                  </li>
                  <li>
                    Apple juice or cider (64 oz)
                  </li>
                  <li>
                    Stuffing
                  </li>
                  <li>
                    Eggs &amp; egg cartons (please
                    take eggs directly to the
                    fridge in the food closet)
                  </li>
                </ul>

                <h3>You can help struggling families by:</h3>

                <ul style={{ paddingLeft: '16px', textAlign: 'left' }}>
                  <li>
                    Donating food items.
                  </li>
                  <li>
                    Registering at <a href="https://smile.amazon.com" target="_blank" rel="noopener noreferrer">amazon.com</a> to deliver food directly to
                    the church.
                  </li>
                  <li>
                    Volunteering Tuesday
                    mornings at the Food
                    Closet.
                  </li>
                  <li>
                    Supporting fundraisers
                    (purchase a parish
                    cookbook!)
                  </li>
                  <li>
                    Writing a check to Holy
                    Cross, memo: Food Closet.
                  </li>
                </ul>

                <h3>Thank you again for your support.</h3>

                <p>Questions: Contact Ginny Nelson or Fr. Andrew Jacobs</p>
              </div>
            </div>
          </div>

          <div className="right">
            <div className="section">
              <h3 className="eyebrow">
                Recent Events
              </h3>
              <h2 className="title">
                Tragic fire at our Mother Parish
              </h2>

              <div className="article-body" style={{ marginBottom: '32px' }}>
                <p>
                  On July 12, tragedy struck the Holy Myrrhbearing
                  Women in West Sacramento when an electrical
                  fire broke out in the church. The fire destroyed
                  the interior of the church and has likely
                  compromised the structure itself. Adding to the
                  difficulty, the parish’s insurance will cover only
                  a portion of what is needed to rebuild.
                </p>
                <p>
                  Holy Myrrhbearers is the oldest Orthodox parish
                  in Sacramento. The church temple was
                  constructed in 1925 through the labors and
                  sacrifices of the parishioners.
                </p>
                <p>
                  In the midst of the recent tragedy, God’s mercy
                  and care is evident. Three icons survived the fire
                  unharmed: the Kazan Icon of the Mother of God,
                  St. Nicholas the Wonderworker and St. John of
                  Shanghai and San Francisco. Many parish
                  communities have responded with help,
                  including Holy Cross. To date Holy Cross has
                  donated Liturgical items to aid in resuming
                  Divine services, and parishioners have
                  contributed over $6,000 toward reconstruction
                  efforts. Further donations can be made directly
                  through the website at:&nbsp;<br/>
                  <a href="http://www.holy-women.com/index.php" target="_blank" rel="noopener noreferrer">http://www.holy-women.com/index.php</a>
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title">
                Brewfest &amp; BBQ Fundraiser
              </h2>

              <div className="article-body" style={{ marginBottom: '32px' }}>
                Thank you to everyone who
                supported our "Brewfest & BBQ"
                fundraiser on Saturday, June 30th.
                We featured beers from seven
                different breweries, BBQ’d delicious
                food and raised almost $1,400 for
                our building fund! Stay tuned for
                more fundraising events and
                opportunities to help build our
                church!
              </div>

              <h2 className="title" style={{ marginBottom: '1rem' }}>
                Archangel Michael Food Closet - more than just food!
              </h2>

              <img src={ require('../../../assets/images/news/newsletter-september-2018-food-closet.png') } alt="Food Closet" />

              <div className="article-body">
                <p>
                  The Archangel Michael Food Closet
                  provides food for 66 families every
                  month, 40 of whom have school age
                  children.
                </p>
                <p>
                  In addition to the weekly food
                  program, bags of basic school supplies
                  (pencils, paper, glue, etc.) were
                  distributed to 83 students in grades
                  kindergarten through high school at
                  the beginning of the current school
                  year.
                </p>
                <p>
                  Many of the families expressed
                  gratitude and appreciation. Donations
                  from Elevation of the Holy Cross and
                  St. Athanasius Antiochian Orthodox
                  Church parishioners helped defray
                  the cost. We are blessed to be able to
                  provide this additional outreach to
                  our local community.
                </p>
              </div>
            </div>

            <div className="section">
              <h2 className="title" style={{ marginBottom: '1rem' }}>
                Building Fund Updates
              </h2>

              <img src={ require('../../../assets/images/news/newsletter-june-2018-church-model.jpg') } alt="Church Model" />

              <div className="article-body">
                <ul style={{ paddingLeft: '0', marginBottom: '0' }}>
                  <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong>YTD Raised:</strong> <span>$16,286.35</span>
                  </li>
                  <li style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(0, 0, 0, .2)' }}>
                    <strong>Pledging families:</strong> <span>14</span>
                  </li>
                  <li style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong>Total:</strong> <strong>$285,842.84</strong>
                  </li>
                </ul>

                <span style={{ fontSize: '1rem' }}>
                  Numbers as of August 31, 2018
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="article-footer">
          9000 Jackson Rd, Sacramento, CA 95826 <Link to={ `/` }>holycrosssacramento.org</Link><br/>
          Mailing: 2443 Fair Oaks Blvd #295, Sacramento, CA 95825
        </div>
      </div>
    </div>
  );
}

export default newsletterSeptember2018;
